// src/components/Footer.tsx
import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="siteFooter">
      <div className="footer-links">
        <a href="/terms">利用規約</a>
        <a href="/privacy">プライバシーポリシー</a>
        <a href="/law">特定商取引法</a>
        <a href="/faq">FAQ</a>
        <a href="/contact">お問い合わせ</a>
      </div>
      <div className="copyright">
        © {new Date().getFullYear()} BOAT億MAN All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
